module.exports = __webpack_public_path__ + "static/Menos plastico-a0dd5add76260c77c23ba67dd6adac00.png";